import { NextSeo, BreadcrumbJsonLd } from 'next-seo';
import AboutPageTemplate, { AboutPageTemplateProps } from './template';

const AboutPage: React.FC<AboutPageTemplateProps> = ({ metaTitle, metaDescription, ...props }) => {
  const SEO = {
    title: metaTitle,
    description: metaDescription,
    openGraph: {
      type: 'website',
      locale: 'pt',
      url: `${process.env.NEXT_PUBLIC_SITE_URL}/sobre` || 'http://localhost:3000',
      ['site_name']: 'App Masters Academy',
    },
  };
  const itemListElements = [
    {
      position: 1,
      name: metaTitle || '',
      item: `${process.env.NEXT_PUBLIC_SITE_URL}/sobre` || 'http://localhost:3000',
    },
  ];

  return (
    <>
      <BreadcrumbJsonLd itemListElements={itemListElements} />
      <NextSeo {...SEO} />
      <AboutPageTemplate {...props} />
    </>
  );
};

export default AboutPage;
